import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid2 } from '@mui/material';
import { useState } from 'react';
import useStyles from './PromoContentGallery.styles';
import PromoContentItem from '../PromoContentItem/PromoContentItem';
import Alert from '../Alert/Alert';
import PromoContentGalleryCarousel from './PromoContentGalleryCarousel/PromoContentGalleryCarousel';
const PromoContentGallery = ({ title, description, items, addDeliveryPassToCart, sendPromoContentGalleryAnalytics, headingTag, galleryDisplayType = 'GRID', }) => {
    const { classes } = useStyles();
    const [errorMessage, setErrorMessage] = useState('');
    const halfWidth = items && (items === null || items === void 0 ? void 0 : items.length) % 2 === 0;
    const HeadingTag = (headingTag ? headingTag.toLowerCase() : 'h2');
    const addDeliveryPass = (sku) => {
        addDeliveryPassToCart &&
            addDeliveryPassToCart(sku)
                .then(() => setErrorMessage(''))
                .catch((error) => {
                setErrorMessage(error.message);
            });
    };
    const isCarouselGalleryDisplay = galleryDisplayType === 'CAROUSEL';
    const tagMap = {
        h1: 'h2',
        h2: 'h3',
        h3: 'h4',
        h4: 'div',
        div: 'div',
    };
    const itemHeadingTag = tagMap[HeadingTag] || 'h3';
    const renderGrid = () => (_jsx(Grid2, { container: true, spacing: 3, className: classes.productGrid, children: items.map((item, index) => (_jsx(Grid2, { className: classes.gridItem, size: { md: halfWidth ? 6 : 4 }, children: _jsx(PromoContentItem, Object.assign({}, item, { itemIndex: index, halfWidth: halfWidth, headingTag: itemHeadingTag, addDeliveryPassToCart: addDeliveryPass, sendPromoContentGalleryAnalytics: sendPromoContentGalleryAnalytics })) }, `${index}${item.heading}`))) }));
    const renderCarousel = () => (_jsx(PromoContentGalleryCarousel, { items: items, halfWidth: halfWidth, itemHeadingTag: itemHeadingTag, addDeliveryPassToCart: addDeliveryPass, sendPromoContentGalleryAnalytics: sendPromoContentGalleryAnalytics }));
    return (_jsxs("div", { className: classes.gallery, children: [(title || description) && (_jsxs("div", { className: classes.headingSection, children: [title && _jsx(HeadingTag, { className: classes.title, children: title }), description && _jsx("p", { children: description })] })), errorMessage && _jsx(Alert, { className: classes.error, type: "alertError", message: errorMessage }), !!(items === null || items === void 0 ? void 0 : items.length) && (isCarouselGalleryDisplay ? renderCarousel() : renderGrid())] }));
};
export default PromoContentGallery;
